import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import nb from 'i18n-iso-countries/langs/nb.json';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Language, { DEFAULT_LANGUAGE } from 'constants/language';
countries.registerLocale(en);
countries.registerLocale(nb);
const useCountry = () => {
  const {
    i18n
  } = useTranslation();
  const mapCountryNames = countryNames => Object.entries(countryNames).map(([code, value]) => ({
    code,
    name: Array.isArray(value) ? value[0] : value
  })).sort((a, b) => a.name?.localeCompare(b.name));
  const [countryList, setCountries] = useState(null);
  const getChosenCountryObject = lang => countryList?.find(country => country.code === lang);
  const getChosenCountryObjectName = lang => countryList?.find(country => country.code === lang)?.name ?? '';
  const getDefaultCountry = countryCode => {
    if (!countryCode) return getChosenCountryObject(DEFAULT_LANGUAGE);
    return getChosenCountryObject(countryCode);
  };
  useEffect(() => {
    const language = i18n.languages[0] === Language.norwegian ? Language.norwegianBokmal : Language.english;
    const countryNames = countries.getNames(language);
    setCountries(mapCountryNames(countryNames));
  }, [i18n.languages]);
  return {
    countryList,
    getChosenCountryObject,
    getChosenCountryObjectName,
    getDefaultCountry
  };
};
export default useCountry;